import { createSlice } from '@reduxjs/toolkit';
import { generateReduxKeys } from '../../utils';

const initialState = generateReduxKeys({
    promotions: [],
});

const promotionsSlice = createSlice({
    name: 'promotions',
    initialState,
    reducers: {
        setPromotions: (state, action) => {
            state.promotions = action.payload;
        },
    },
});

export const { setPromotions } = promotionsSlice.actions;

export default promotionsSlice.reducer;